// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__R56Df","link":"Footer_link__RQuxH","social-icons":"Footer_social-icons__Jn8fH"};